<template>
    <div class="moreFunction main_width main_color m_0 ">
        <div class="title">更多数据查询功能</div>
        <swiper class="swiper" :options="swiperOption" ref="swiper">
            <swiper-slide class="swiper_item" v-for="(item, index) in list" :key="index">
                <div class="swiper_top">
                    <div class="swiper_top_left" @click="buttonPrev"><span>{{ item.titleLeft }}</span></div>
                    <div class="swiper_top_center">
                        <p>{{ item.title }}</p>
                        <div>{{ item.desc }}</div>
                    </div>
                    <div class="swiper_top_right" @click="buttonNext"><span>{{ item.titleRight }}</span></div>
                </div>
                <img :src="item.img" alt="">
            </swiper-slide>
            <div class="swiper-button swiper-button-prev" slot="button-prev" ref="buttonPrev">
                <img src="../../../static/images2/return_left.webp" alt="">
            </div>
            <div class="swiper-button swiper-button-next" slot="button-next">
                <img src="../../../static/images2/return_right.webp" alt="">
            </div>
        </swiper>
    </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import moreFunction1 from '../../../static/images2/moreFunction1.webp'
import moreFunction2 from '../../../static/images2/moreFunction2.webp'
import moreFunction3 from '../../../static/images2/moreFunction3.webp'
import moreFunction4 from '../../../static/images2/moreFunction4.webp'
import moreFunction5 from '../../../static/images2/moreFunction5.webp'
import moreFunction6 from '../../../static/images2/moreFunction6.webp'
export default {
    name: 'moreFunction',
    components: {
      swiper,
      swiperSlide
    },
    data() {
        return {
            list: [
                {
                    titleLeft: '厂家配置查询',
                    title: '发动机号查询',
                    titleRight: 'OBD故障码查询',
                    desc: '发动机号查询对维修厂修车至关重要。借助发动机号， 能查到发动机型号、规格、尺寸、工作方式等信息。',
                    img: moreFunction1
                },
                {
                    titleLeft: '发动机号查询',
                    title: 'OBD故障码查询',
                    titleRight: '品牌件查询',
                    desc: 'OBD故障码查询功能，能查到故障码对应的原因解读与应对策略，主力维修厂更精准诊断车况、维修车辆',
                    img: moreFunction2
                },
                {
                    titleLeft: 'OBD故障码查询',
                    title: '品牌件查询',
                    titleRight: '典型故障查询',
                    desc: '该功能汇聚博世、盖茨等多个主流汽配品牌厂商。用户通过车架号或具体车型及产品编号查询可用产品',
                    img: moreFunction3
                },
                {
                    titleLeft: '品牌件查询',
                    title: '典型故障查询',
                    titleRight: '保养计划定制',
                    desc: '聚合主流车辆款型及车系常见故障。用户在购车前或维修时，借助该功能可了解车辆潜在风险。',
                    img: moreFunction4
                },
                {
                    titleLeft: '典型故障查询',
                    title: '保养计划定制',
                    titleRight: '厂家配置详情查询',
                    desc: '为车主提供车辆保养计划查询服务。输入车型、行驶里程后，系统会智能生成保养项目和计划',
                    img: moreFunction5
                },
                {
                    titleLeft: '保养计划定制',
                    title: '厂家配置查询',
                    titleRight: '发动机号查询',
                    desc: '凭车架号(VIN)查询特定车型零部件配置参数及型号，助力商家用户快速购买适配商品',
                    img: moreFunction6
                },
            ],
            swiperOption: {
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }
    },
    methods: {
        buttonPrev() {
            this.$refs.swiper.swiper.slidePrev()
        },
        buttonNext() {
            this.$refs.swiper.swiper.slideNext()
        }
    }
}
</script>
<style scoped lang="less">
@import "../../assets/style/utils.less";
div {
    box-sizing: border-box;
}
.moreFunction {
    width: .px2vw(1280)[@result];
    text-align: center;
    margin-bottom: .px2vw(164)[@result];
    .title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(32)[@result];
    }
    .swiper {
        .swiper_top {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: .px2vw(36)[@result];
            & > div {
                width: .px2vw(368)[@result];
                height: .px2vw(132)[@result];
                font-size: .px2vw(20)[@result];
                color: rgba(29,33,41,0.4);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            & > .swiper_top_center {
                font-size: .px2vw(14)[@result];
                color: #4E5969;
                margin: 0 .px2vw(24)[@result];
                line-height: .px2vw(22)[@result];
                p {
                    font-weight: 500;
                    font-size: .px2vw(20)[@result];
                    color: #1D2129;
                    margin-bottom: .px2vw(12)[@result];
                    line-height: .px2vw(28)[@result];
                }
            }
            .swiper_top_left {
                span {
                    cursor: pointer;
                    transition: transform 0.3s ease;
                }
                span:hover {
                    transform: scale(1.1); // 放大到 1.2 倍
                }
            }
            .swiper_top_right {
                span {
                    cursor: pointer;
                    transition: transform 0.3s ease;
                }
                span:hover {
                    transform: scale(1.1); // 放大到 1.2 倍
                }
            }
        }
        & > img {
            width: .px2vw(230)[@result];
            height: .px2vw(498)[@result];
        }
        .swiper-button {
            width: .px2vw(64)[@result];
            height: .px2vw(64)[@result];
            background: #E8E9ED;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: .px2vw(32)[@result];
                height: .px2vw(32)[@result];
            }
        }
    }

}
@media screen and (max-width: 900px) {
    .moreFunction {
        .title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(32)[@result];
        }
        .swiper {
            .swiper_top {
                margin-bottom: .h5px2vw(48)[@result];
                & > div {
                    width: .h5px2vw(368)[@result];
                    height: .h5px2vw(132)[@result];
                    font-size: .h5px2vw(20)[@result];
                }
                & > .swiper_top_center {
                    font-size: .h5px2vw(14)[@result];
                    margin: 0;
                    line-height: .h5px2vw(22)[@result];
                    p {
                        font-size: .h5px2vw(20)[@result];
                        margin-bottom: .h5px2vw(12)[@result];
                        line-height: .h5px2vw(28)[@result];
                    }
                }
                .swiper_top_left {
                    display: none;
                }
                .swiper_top_right {
                    display: none;
                }
            }
            .swiper_item img {
                width: .h5px2vw(230)[@result];
                height: .h5px2vw(498)[@result];
            }
            .swiper-button {
                width: .h5px2vw(64)[@result];
                height: .h5px2vw(64)[@result];
                img {
                    width: .h5px2vw(32)[@result];
                    height: .h5px2vw(32)[@result];
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/QXB/moreFunction.vue